__turbopack_context__.v({
  "fullSchedule": "igu8jG_fullSchedule",
  "label": "igu8jG_label",
  "scroller": "igu8jG_scroller",
});
